module.exports = __webpack_public_path__ + "static/media/J1_GLOSS.90b494e1.png";